import React from 'react';
import { Star, Quote } from 'lucide-react';
import { motion } from 'framer-motion';

export const Testimonials = () => {
  const reviews = [
    {
      name: "James",
      role: "Verified Buyer",
      content: "Using Simba Herbals' Tonga Bull has increased my stamina and performance in the bedroom. My confidence soared!",
      rating: 5,
      image: "https://randomuser.me/api/portraits/men/32.jpg"
    },
    {
      name: "Kuda",
      role: "Verified Buyer",
      content: "Simba Herbals' Libido Boost Formula brought back my energy and desire. I feel more passionate and vibrant!",
      rating: 5,
      image: "https://randomuser.me/api/portraits/men/45.jpg"
    },
    {
      name: "Joshua",
      role: "Verified Buyer",
      content: "After a month of using Simba Herbals’ natural supplements, my sexual performance and endurance have significantly improved!",
      rating: 5,
      image: "https://randomuser.me/api/portraits/men/22.jpg"
    }
  ];

  return (
    <section className="py-24 bg-simba-dark text-white relative overflow-hidden">
      {/* Background Decor */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-simba-green/20 rounded-full blur-[100px] pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-simba-gold/10 rounded-full blur-[100px] pointer-events-none"></div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 relative z-10">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16">
          <div className="max-w-xl">
            <span className="text-simba-gold font-bold text-sm uppercase tracking-widest mb-4 block">
              Testimonials
            </span>
            <h2 className="font-display font-medium text-4xl lg:text-5xl leading-tight">
              Client Feedback <br/>
              <span className="italic text-simba-green">& Reviews</span>
            </h2>
          </div>
          <div className="hidden md:flex items-center space-x-2">
            <div className="h-[2px] w-12 bg-white/20"></div>
            <span className="font-body text-sm text-white/60">Rated 4.7/5 stars by thousands</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reviews.map((review, i) => (
            <motion.div 
              key={i} 
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
              whileHover={{ y: -5, scale: 1.02 }}
              className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-2xl hover:bg-white/10 transition-colors duration-300"
            >
              <div className="flex justify-between items-start mb-6">
                <div className="flex text-simba-gold">
                  {[...Array(review.rating)].map((_, i) => (
                    <Star key={i} size={16} fill="currentColor" />
                  ))}
                </div>
                <Quote size={32} className="text-simba-green/40" />
              </div>
              
              <p className="font-body text-lg text-simba-cream/90 leading-relaxed mb-8 italic">
                "{review.content}"
              </p>
              
              <div className="flex items-center space-x-4">
                <img 
                  src={review.image} 
                  alt={review.name} 
                  className="w-12 h-12 rounded-full border-2 border-simba-gold/30" 
                />
                <div>
                  <h4 className="font-display font-bold text-lg">{review.name}</h4>
                  <p className="text-xs text-simba-green uppercase tracking-wider font-bold">{review.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
